/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class AnnouncementService implements IAnnouncementService {
    public static $inject = ['Api'];

    public announcements: IAnnouncementElement[];
    public AnnounceModel;

    constructor (private Api: Restangular.IService) {
        this.announcements = [];
        this.AnnounceModel = Api.service('announcements');
    }

    public loadAnounces(): Restangular.IPromise<any> {
        let promise: Restangular.IPromise<any> = this.AnnounceModel.getList();

        promise.then((response: IAnnouncementElement[]) => {
            this.announcements = response
            // response.forEach((announcement: IAnnouncementElement) => {
            //     this.announcements.push(announcement);
            // });
        });

        return promise;
    };

    public getAnnounces(): any {
        return this.announcements;
    }

    public createAnnounce(announcement: IAnnouncementElement): Restangular.IPromise<any> {
        let promise: Restangular.IPromise<any> = this.Api.restangularizeElement(undefined, announcement, 'announcements').save();

        promise.then((response: IAnnouncementElement) => {
            this.announcements.push(response);
        });

        return promise;
    }

    public editAnnounce(announcement: IAnnouncementElement, index: number): Restangular.IPromise<any> {
        let promise: Restangular.IPromise<any> = announcement.put();

        promise.then((response: IAnnouncementElement) => {
            this.announcements[index] = response;
        });

        return promise;
    }

    public moveAnnouncementToArchive(announcement: IAnnouncementElement, index: number): Restangular.IPromise<any> {
        announcement.active = false;
        let promise: Restangular.IPromise<any> = announcement.patch();

        promise.then((response: IAnnouncementElement) => {
            this.announcements.splice(index, 1);
        });

        return promise;
    }

    public dismissAnnounce(announcement: IAnnouncementElement): Restangular.IPromise<any> {
        return this.AnnounceModel.one(announcement.id).remove();
    }

    public clearService(): void {
        this.announcements.length = 0;
    }
}


angular.module('beneple.global')
    .service('Announcement', AnnouncementService);



// WEBPACK FOOTER //
// ./frontend/scripts/announcement/services/announcement.service.ts